import { forwardRef } from 'react';
import {
  StyledDrawerLink,
  StyledDrawerLinkButton,
  StyledDrawerText,
} from './styled';
import { useDrawerContext } from '../../../contexts/drawer';
import Icon from '../../../components/Icon';

const DrawerLink = forwardRef((props, ref) => {
  const { as, children, ...rest } = props;
  const { linkProps } = useDrawerContext();

  if (as === 'button') {
    return (
      <StyledDrawerLinkButton {...linkProps(ref, rest)}>
        {rest.isActive ? (
          <>
            <StyledDrawerText>{children}</StyledDrawerText>
            <Icon name="check" />
          </>
        ) : (
          <StyledDrawerText>{children}</StyledDrawerText>
        )}
      </StyledDrawerLinkButton>
    );
  } else {
    return (
      <StyledDrawerLink {...linkProps(ref, rest)}>
        {rest.isActive ? (
          <>
            <StyledDrawerText>{children}</StyledDrawerText>
            <Icon name="check" />
          </>
        ) : (
          <StyledDrawerText>{children}</StyledDrawerText>
        )}
      </StyledDrawerLink>
    );
  }
});

export default DrawerLink;
